import { render, staticRenderFns } from "./DownBtnIcon.vue?vue&type=template&id=4ec720c6&scoped=true"
import script from "./DownBtnIcon.vue?vue&type=script&lang=js"
export * from "./DownBtnIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec720c6",
  null
  
)

export default component.exports